<style>
	.mdc-text-field {
		border-top-left-radius: 4px;
		border-top-left-radius: var(--mdc-shape-small, 4px);
		border-top-right-radius: 4px;
		border-top-right-radius: var(--mdc-shape-small, 4px);
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		display: inline-flex;
		align-items: baseline;
		position: relative;
		box-sizing: border-box;
		overflow: visible;
		will-change: color;
	}

	:global(.date-time-field > input) {
		border-top-style: hidden !important;
		border-right-style: hidden !important;
		border-left-style: hidden !important;
		border-radius: 0px !important;
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
		font-family: 'Roboto', sans-serif;
		font-size: 1rem;
		font-size: var(--mdc-typography-subtitle1-font-size, 1rem);
		font-weight: 400;
		font-weight: var(--mdc-typography-subtitle1-font-weight, 400);
		letter-spacing: 0.009375em;
		letter-spacing: var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);
		text-decoration: inherit;
		text-decoration: var(--mdc-typography-subtitle1-text-decoration, inherit);
		text-transform: inherit;
		text-transform: var(--mdc-typography-subtitle1-text-transform, inherit);
		height: 2em;
		transition: opacity 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);
		width: 100%;
		min-width: 0;
		border: none;
		border-radius: 0;
		background: none;
		appearance: none;
		padding: 0 !important;
	}

	:global(.date-time-field > input::placeholder) {
		--tw-text-opacity: 1;
		color: rgb(75 85 99 / var(--tw-text-opacity)) !important;
	}

	:global(.date-time-field > input:disabled::placeholder) {
		--tw-text-opacity: 1;
		color: rgb(156 163 175 / var(--tw-text-opacity)) !important;
	}

	:global(.date-time-field) {
		bottom: -5px;
		width: 100%;
	}

	:global(.date-time-field > input:hover) {
		border-bottom: 1px solid #000 !important;
	}

	:global(.date-time-field > input:focus) {
		border-bottom: 0px !important;
		background-size: 100% 2px !important;
	}

	:global(body) {
		--date-picker-foreground: #000 !important;
		--date-picker-background: #ffffff !important;
		--date-picker-highlight-border: #6ab42d !important;
		--date-picker-highlight-shadow: none !important;
		--date-picker-selected-color: #6ab42d !important;
		--date-picker-selected-background: #ffffff !important;
		--date-input-width: 100% !important;
	}

	:global(.invalid) {
		background-color: inherit !important;
		color: red !important;
		border: none !important;
		border-bottom: 1px solid red !important;
		box-shadow: none !important;
	}

	:global(.invalid:focus) {
		background-color: inherit !important;
		color: red !important;
		border: none !important;
		border-bottom: 1px solid red !important;
		box-shadow: none !important;
	}
</style>

<script>
	import { DateInput, localeFromDateFnsLocale } from 'date-picker-svelte';
	import { it } from 'date-fns/locale';

	let locale = localeFromDateFnsLocale(it);
	export let label;
	export let value = null;
	export let placeholder = 'dd/MM/yyyy';
	export let format = 'dd/MM/yyyy';
	export let min = new Date('1970-01-01T00:00:00');
	export let max = new Date('2100-12-31T00:00:00');
	export let disabled = false;

	$: {
		if (value) {
			value = new Date(value);
			value.setHours(11, 0, 0);
		} else {
			value = null;
		}
	}
</script>

<!-- svelte-ignore a11y-label-has-associated-control -->
<label class="mdc-text-field smui-text-field--standard mdc-text-field--label-floating w-full">
	<span class="mdc-floating-label mdc-floating-label--float-above">{label}</span>
	<DateInput locale="{locale}" disabled="{disabled}" bind:value="{value}" placeholder="{placeholder}" format="{format}" min="{min}" max="{max}" />
</label>
